import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import ActorCostume from '../../../domain/entities/ActorCostume';

export default function reducer(
  state: {[key: number]: ActorCostume} = {},
  action: AnyAction,
): {[key: number]: ActorCostume} {
  switch (action.type) {
    case Types.IndexActorCostumesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: ActorCostume}, record: ActorCostume) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
